import { SheetWithFormComponent } from '@/components/ui/SheetWithFormComponent'
import { cn } from '@/lib/utils'
import { useState } from 'react'
import { TemplateActivityLog } from '../../DataTableComponent/RowActions/TemplateActivityLog'
import { StepperStepBody } from './StepperStepBody'
import { useStepperStepContext } from './StepperStepContext'

export function StepUploadTemplate() {
  const [sheetOpen, setSheetOpen] = useState(false)
  const { action, stepData, contentClassName } = useStepperStepContext()

  if (action.type !== 'uploadtemplate') return null

  const { entityGUID: entityGUIDParam, templateKey: templateKeyParam } = action.parameter_mappings
  if (!entityGUIDParam || !templateKeyParam) return null

  const entityGuid = (stepData as Record<string, string>)[entityGUIDParam] ?? ''
  const templateKey = (stepData as Record<string, string>)[templateKeyParam] ?? ''
  if (!entityGuid || !templateKey) return null

  return (
    <SheetWithFormComponent
      title="Upload template"
      description="Upload a template for the entity."
      trigger={
        <button type="button" className={cn(contentClassName)}>
          <StepperStepBody />
        </button>
      }
      wide
      isOpen={sheetOpen}
      onOpenChange={setSheetOpen}
    >
      <TemplateActivityLog entityGuid={entityGuid} templateKey={templateKey} />
    </SheetWithFormComponent>
  )
}
